import React from 'react';
import { Route } from 'react-router-dom';
import Country from './screens/Country/Country';
import Currency from './screens/Currency/Currency';
import Language from './screens/Language/Language';
import { SCREENS } from 'src/constants/screens';
import { Table } from 'src/view/components/Table/Table';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import ScreenTabsNavigation from 'src/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';

const LanguageCountryCurrency = () => {
  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack className="pl-2" title="language_country_and_currency_section" path={SCREENS.SETTINGS()} />
      </Headers>
      <div className="d-flex flex-column flex-grow-1 pt-6">
        <Table>
          <>
            <ScreenTabsNavigation
              className="pl-2"
              options={[
                { path: SCREENS.SETTINGS_COUNTRIES(), title: 'country' },
                { path: SCREENS.SETTINGS_CURRENCY(), title: 'currency' },
                // { path: SCREENS.SETTINGS_TRANSLATION(), title: 'translations' },
              ]}
            />
            <Route path={SCREENS.SETTINGS_COUNTRIES()} component={Country} />
            <Route path={SCREENS.SETTINGS_CURRENCY()} component={Currency} />
            {/*<Route path={SCREENS.SETTINGS_TRANSLATION()} component={Language} />*/}
          </>
        </Table>
      </div>
    </div>
  );
};

export default LanguageCountryCurrency;
